(function () {
  'use strict';

  d3.chart('ChartBase').extend('PieChart', {

    initialize: function () {
      var plot = this;

      plot.base.classed('PieChart', true);

      plot.layers = {
        legend : plot.wrap.append('g').classed('legend', true),
        slices : plot.wrap.append('g').classed('slices', true),
        labels : plot.wrap.append('g').classed('labels', true)
      };

      plot.layer('slices', plot.layers.slices, {
        dataBind: function (data) {
          return this.selectAll('.slice-group')
              .data(plot.pie(data.data));
        },
        insert: function () {
          var group = this.append('g').classed('slice-group', true);

              group.append('path')
              .classed('slice', true)
              .attr('fill', function (d, i) {
                return d.data.color;
              });

          return group;
        },
        events : {
          exit : function() {
            this.remove();
          },
          merge : function () {
            var slice = this;

            slice.select('.slice')
                .attr('d', plot.arc)
                .attr('fill', function (d) {
                  return d.data.color;
                })
                .transition()
                .duration(750)
                .attrTween('d', function(d){
                  var i = d3.interpolate(d.startAngle+0.1, d.endAngle);
                  return function(t){
                    d.endAngle = i(t);
                    return plot.arc(d);
                  }
                });
          }
        }
      });

      plot.layer('labels', plot.layers.labels, {
        dataBind: function (data) {
          return this.selectAll('.labels-group')
              .data(plot.pie(data.data));
        },
        insert: function () {
          var group = this.append('g').classed('labels-group', true);

          group.append('text')
              .classed('labels-value', true)
              .style("font-weight","bold")
              .attr('alignment-baseline', 'middle')
              .attr('text-anchor', 'middle')
              .attr('font-family', 'Gotham Medium, sans-serif');

          return group;
        },
        events : {
          exit : function() {
            this.remove();
          },
          merge : function () {
            var slice = this;

            function positionLabel(startAngle, endAngle, trigFn) {
              var radius = plot.data.data.length > 1 ? plot.r : 0;
             return radius/2 * trigFn((endAngle + startAngle)/2 - Math.PI / 2);
            }

            slice.select('.labels-value')
                .text(function (d) {return plot.data.fn.sliceLabel(d);})
                .attr('x', function(d){return positionLabel(d.startAngle, d.endAngle, Math.cos)})
                .attr('y', function(d){return positionLabel(d.startAngle, d.endAngle, Math.sin)});

          }
        }
      });

      plot.layer('legend', plot.layers.legend, {
        dataBind : function (data) {
          return this.selectAll('.legend-series')
              .data(data.data);
        },
        insert: function () {

          var boxSize = 15;

          var group = this.append('g')
              .classed('legend-series', true);

          group.append('rect')
              .classed('legend-box', true)
              .attr('width', boxSize)
              .attr('height', boxSize);

          group.append('text')
              .classed('legend-text', true)
              .attr('font-family', 'Gotham, sans-serif')
              .attr("dominant-baseline", "central")
              .translate(20, boxSize/2);

          return group;
        },
        events : {
          exit : function() {
            this.remove();
          },
          merge : function () {
            this.select('rect')
                .style({fill : function (d) { return d.color }});

            this.select('text')
                .text(_.property('name'));

            // todo: this could be abstracted into a utility
            var lefts = [0]; // the first one starts at 0
            var SPACING = 25;
            this.each(function () {
              var left = lefts[lefts.length - 1];
              var next = left + this.getBBox().width + SPACING;
              lefts.push(next);

              d3.select(this).translate(function(d,i){
                return [plot.width() / 2 - left + SPACING/2, plot.height() - 30]});
            });
          }
        }
      });

      function onDimensionChange() {
        var chartSpacing = 20;
        var centerX = plot.width() / 2,
            centerY = plot.height() / 2 - chartSpacing;

        plot.layers.slices
            .translate(centerX, centerY);

        plot.layers.labels
            .translate(centerX, centerY);
      }

      plot.on("change:height", onDimensionChange);
      plot.on("change:width", onDimensionChange);
    },
    transform: function (data) {

      if(data !== this.data) {
        this.data = data;

        _.defaults(data, {
          radius : 100,
          data : []
        });

        this.data = data;
        this.r = this.data.radius;

        this.arc = d3.svg.arc()
            .outerRadius(this.r);

        this.pie = d3.layout.pie()
            .sort(null)
            .value(function (d) {
              return d.value;
            });
      }

      return data;

    }
  });

})();